import { createSlice } from "@reduxjs/toolkit";
import Api from "../../api/Api";

type State = {
	data: Object,
	isLoading: boolean,
	error: Object | null
}

// Slice
const slice = createSlice({
	name: "brandsettings",
	initialState: {
		data: {},
		isLoading: true,
		error: null,
	},
	reducers: {
		fetchBrandSettingsStart: (state: State) => {
			state.isLoading = true;
		},
		fetchBrandSettingsSuccess: (state: State, action) => {
			state.isLoading = false;
			state.data = action.payload;
		},
		fetchBrandSettingsFailed: (state: State, action) => {
			state.isLoading = false;
			state.error = action.payload;
		}
	},
});

export default slice.reducer;

// Actions
const {
	fetchBrandSettingsStart,
	fetchBrandSettingsSuccess,
	fetchBrandSettingsFailed
} = slice.actions;

export const getBrandSettings = () => async (dispatch: Function) => {
	try {
		dispatch(fetchBrandSettingsStart());
		const api = new Api();
		const result = await api.getBrandSettings();
		dispatch(fetchBrandSettingsSuccess(result));
	} catch (err: any) {
		dispatch(fetchBrandSettingsFailed(err));
	}
};
